import { Text, TextProps } from '@mantine/core'
import React from 'react'

import { NOT_APPLICABLE } from '@/configs'
import { isNumber } from '@/utils/number'

import { formatPercentageColor, formatPercentageWithLimit } from '../utils/number/format'

interface PriceChangeProps extends TextProps {
  value: unknown
}

export default function PriceChange({ value, ...restProps }: PriceChangeProps) {
  if (!isNumber(value)) {
    return NOT_APPLICABLE
  }
  const percentage = formatPercentageWithLimit(value * 100)
  const changeColor = formatPercentageColor(Number(percentage.replace('%', '')))
  const changeSymbol = value > 0 ? '+' : ''
  return (
    <Text component="span" c={changeColor} {...restProps}>
      {changeSymbol}
      {percentage}
    </Text>
  )
}
